import { render, staticRenderFns } from "./ClientThreads.vue?vue&type=template&id=02e96f98&"
import script from "./ClientThreads.vue?vue&type=script&lang=js&"
export * from "./ClientThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports